import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSlot,
} from "@/components/ui/input-otp";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { useAppDispatch } from "@/hooks/useAppDispatch";
import { useAppSelector } from "@/hooks/useAppSelector";
import { verifyRequest } from "@/store/slices/authSlice";

const Verify = () => {
  const [code, setCode] = useState("");
  const { toast } = useToast();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { loading, error, verificationPending } = useAppSelector((state) => state.auth);

  useEffect(() => {
    if (!verificationPending) {
      navigate("/company-setup");
    }
  }, [verificationPending, navigate]);

  useEffect(() => {
    if (error?.error?.detail?.general) {
      toast({
        variant: "destructive",
        title: "Verification failed",
        description: error.error.detail.general[0],
      });
      setCode("");
    }
  }, [error, toast]);

  useEffect(() => {
    if (code.length === 6) {
      handleVerify();
    }
  }, [code]);

  const handleVerify = async (e?: React.FormEvent) => {
    e?.preventDefault();
    if (code.length !== 6) {
      toast({
        variant: "destructive",
        title: "Invalid code",
        description: "Please enter a 6-digit verification code.",
      });
      return;
    }

    dispatch(verifyRequest(code));
  };

  return (
    <div className="container max-w-md mx-auto py-10">
      <div className="text-center space-y-6">
        <h1 className="text-2xl font-bold">Verify Your Account</h1>
        <p className="text-muted-foreground">
          Please enter the verification code sent to your WhatsApp.
        </p>
        
        <Alert>
          <AlertDescription>
            A 6-digit verification code has been sent to your phone number.
          </AlertDescription>
        </Alert>
        
        <form onSubmit={handleVerify} className="space-y-6">
          <div className="flex justify-center">
            <InputOTP
              maxLength={6}
              value={code}
              onChange={(value) => setCode(value)}
              disabled={loading}
              autoFocus
            >
              <InputOTPGroup>
                {[...Array(6)].map((_, index) => (
                  <InputOTPSlot key={index} index={index} />
                ))}
              </InputOTPGroup>
            </InputOTP>
          </div>
          
          <Button 
            type="submit" 
            className="w-full"
            disabled={loading || code.length !== 6}
          >
            {loading ? "Verifying..." : "Verify Account"}
          </Button>
        </form>
      </div>
    </div>
  );
};

export default Verify;